import axios from "axios";
import { clone } from "ramda";
import { baseUrl } from "..";
function prepareUrl(options) {
  let url = baseUrl;
  url = url.replace(":company_id", options.companyId);
  return url;
}
export default (axiosConfig, options) => {
  return params => {
    const config = clone(axiosConfig);
    config.method = "POST";
    config.url = prepareUrl(options);
    config.data = Object.assign(Object.assign({}, params), {
      password: btoa(params.password)
    });
    return axios(config);
  };
};